import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { ConfirmationDialog } from "@/components/confirmation-dialog";
import { useLogout } from "@/features/auth";
import { ENV } from "@/features/config";
import { useCountdown } from "@/hooks/use-countdown";
import { useErrorHandler } from "@/hooks/use-error-handler";
import { useIdleTimeout } from "@/hooks/use-idle-timeout";

export const InactivityTimeout = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const inactivityTimeoutMinutes = ENV.APP.INACTIVITY_TIMEOUT_MINUTES || 120;
  const countdown = useCountdown(59 * 1000);
  const { handleUnauthenticatedUser } = useErrorHandler();
  const signout = useLogout();
  const [open, setOpen] = useState(false);

  const onPrompt = () => {
    countdown.reset();
    setOpen(true);
  };

  const onIdle = () => {
    setOpen(false);
    handleUnauthenticatedUser({ state: { from: location, isInactive: true } });
  };

  const { idleTimer } = useIdleTimeout(
    onPrompt,
    onIdle,
    inactivityTimeoutMinutes
  );

  const cancelTimeout = () => {
    setOpen(false);
    idleTimer.reset();
    countdown.reset();
  };

  const handleConfirm = () => {
    setOpen(false);
    signout().catch(() => undefined);
  };

  return (
    <ConfirmationDialog
      onOpenChange={setOpen}
      label="timeout-dialog"
      className="max-w-md"
      open={open}
      title={t("session_to_expire_title")}
      message={
        <span
          dangerouslySetInnerHTML={{
            __html: t("session_to_expire_description_p1", {
              "0": countdown.timeLeftValues.seconds,
            }),
          }}
        />
      }
      confirmButtonText={t("settings_logout")}
      cancelButtonText={t("stay_signed_in")}
      onConfirm={handleConfirm}
      onDismiss={cancelTimeout}
    />
  );
};
